"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClearMountingResetRequestT = exports.ClearMountingResetRequest = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
/**
 * Clears mounting reset data, defaulting to the manually set mounting orientations
 */
class ClearMountingResetRequest {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsClearMountingResetRequest(bb, obj) {
        return (obj || new ClearMountingResetRequest()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsClearMountingResetRequest(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new ClearMountingResetRequest()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static startClearMountingResetRequest(builder) {
        builder.startObject(0);
    }
    static endClearMountingResetRequest(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createClearMountingResetRequest(builder) {
        ClearMountingResetRequest.startClearMountingResetRequest(builder);
        return ClearMountingResetRequest.endClearMountingResetRequest(builder);
    }
    unpack() {
        return new ClearMountingResetRequestT();
    }
    unpackTo(_o) { }
}
exports.ClearMountingResetRequest = ClearMountingResetRequest;
class ClearMountingResetRequestT {
    constructor() { }
    pack(builder) {
        return ClearMountingResetRequest.createClearMountingResetRequest(builder);
    }
}
exports.ClearMountingResetRequestT = ClearMountingResetRequestT;
